module.exports = __webpack_public_path__ + "static/media/supportMessagesSent_15_20.518bd2a1.png";